module.exports = function(ejs) {
var __t, __p = '';
__p += '<ggs-gallery ng-if=":: $ctrl.bootstrap" ggs-bootstrap=":: $ctrl.bootstrap" ggs-main-ready-callback=":: $ctrl.mainReadyCallback"></ggs-gallery><ggs-gallery-overlay ggs-shows-overlay=":: $ctrl.showsOverlay"></ggs-gallery-overlay>';
return __p
}